/**
 * SupplierAddressService
 * Service for Supplier Address entity operations
 * Route: api/supplieraddresses
 */
import { CrudService } from '../base/CrudService';
/**
 * SupplierAddressService
 * Handles supplier address CRUD operations
 */
export class SupplierAddressService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SupplierAddressService.DEFAULT_SERVICE_PATH,
            basePath: SupplierAddressService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CUSTOM METHODS ====================
    /**
     * Get addresses by supplier ID
     * @param supplierId - Supplier ID
     * @returns Array of addresses for the supplier
     */
    async getBySupplier(supplierId) {
        const response = await this.getBySupplierRaw(supplierId);
        return response.data ?? [];
    }
    /**
     * Get addresses by supplier ID (raw)
     * @param supplierId - Supplier ID
     * @returns ResponseData with addresses
     */
    getBySupplierRaw(supplierId) {
        const endpoint = this.getEndpoint('by-supplier', `by-supplier/${supplierId}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
}
SupplierAddressService.DEFAULT_SERVICE_PATH = 'suppliers';
SupplierAddressService.BASE_PATH = 'api/supplieraddresses';
//# sourceMappingURL=SupplierAddressService.js.map